var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupCg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 300,
    viewBox: "0 0 423 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 199.991,
    width: 105.735,
    height: 99.998,
    fill: "#5E5AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.745,
    y: 99.9956,
    width: 105.735,
    height: 99.998,
    fill: "#5E5AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.745 99.998L211.48 0V99.998L105.745 99.998Z",
    fill: "#5E5AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.48 300L105.745 200.002L211.48 200.002L211.48 300Z",
    fill: "#5E5AFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.465,
    y: 199.991,
    width: 105.735,
    height: 99.998,
    fill: "#5E5AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M317.193 99.9956L422.928 199.994L317.193 199.994L317.193 99.9956Z",
    fill: "#5E5AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M422.928 200.002L317.193 300L317.193 200.002L422.928 200.002Z",
    fill: "#5E5AFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.465,
    width: 105.735,
    height: 99.998,
    fill: "#5E5AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCg);
export default __webpack_public_path__ + "static/media/GroupCG.9a0e07febba9551f8f4ada353680b9db.svg";
export { ForwardRef as ReactComponent };